import React from 'react'
import { isNullOrUndefinedOrEmpty } from '../../../../util/Utils'
import TopOperations from '../TopOperations'

export default function CompactMessagesContextMenu({ queueState, compactQueueState, queueActions }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: `${compactQueueState.contextMenu.y}px`,
        insetInlineStart: `${compactQueueState.contextMenu.x}px`,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '5px',
        zIndex: 1000,
      }}
    >
      <TopOperations
        queueState={queueState}
        queueActions={queueActions}
        disabled={isNullOrUndefinedOrEmpty(queueState.selectedCheckboxes)}
      />
    </div>
  )
}
